import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

export enum TrgCheckboxAppearance {
  Square = 'square',
  Circle = 'circle'
};

export enum TrgCheckboxSize {
  Default = '',
  Large = 'large',
  Small = 'small',
  Tiny = 'tiny',
  Tabbed = 'tabbed'
};

@Component({
  selector: 'trg-checkbox',
  templateUrl: './trg-checkbox.component.html',
  styleUrls: ['./trg-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
        '[style.--trg-checkbox-color]': 'color',
        '[style.--trg-checkbox-checked-color]': 'checkedColor',
    },
  standalone: false
})
export class SharedTrgCheckboxComponent {
  @Input() value: boolean;
  @Output() valueChange = new EventEmitter<boolean>();

  @Input() appearance: string | TrgCheckboxAppearance = TrgCheckboxAppearance.Square;
  @Input() size: string | TrgCheckboxSize = TrgCheckboxSize.Default;
  @Input() color = null;
  @Input() checkedColor = null;

  @Input() disabled = false;
  @Input() readonly = false;
  @Input() indeterminate = false;
  @Input() hideIcon = false;
  @Input() hideBorder = false;
  @Input() noText = false;

  constructor() { }


  isUnchecked() {
    return Boolean(this.value) === false;
  }

  isChecked() {
    return Boolean(this.value) === true;
  }


  checkClicked() {
    if (this.disabled || this.readonly) {
      return;
    }

    this.toggle(!this.isChecked());
  }


  toggle(value: boolean) {
    if (value) {
      if (this.isChecked()) {
        return;
      }
    } else {
      if (this.isUnchecked()) {
        return;
      }
    }

    this.valueChange.emit(value);
  }


  // used by the view
  viewIsUnchecked() {
    return !this.indeterminate && this.isUnchecked();
  }

  viewIsChecked() {
    return !this.indeterminate && this.isChecked();
  }
}
